import { Card, Col, Row } from 'antd';
import FormItem from 'components/form/FormItem';
import { useTranslation } from 'react-i18next';
import VNCitySelector from '../VNCitySelector';

export default function AddressInformation() {
  const { t } = useTranslation();

  return (
    <Card title={t('mores.locations.address.title')}>
      <Row gutter={[16, 16]}>
        <VNCitySelector />
        <Col md={12}>
          <FormItem
            name="addressLine"
            label={t('mores.locations.address.addressLine.label')}
            placeholder={t('mores.locations.address.addressLine.placeholder')}
            required
          />
        </Col>
        <Col md={24}>
          <FormItem
            name="locationAddress"
            label={t('mores.locations.address.googleAddress.label')}
            placeholder={t('mores.locations.address.googleAddress.placeholder')}
            required
          />
        </Col>
        <Col md={12}>
          <FormItem
            name="lat"
            label={t('mores.locations.address.lat.label')}
            placeholder={t('mores.locations.address.lat.placeholder')}
          />
        </Col>
        <Col md={12}>
          <FormItem
            name="long"
            label={t('mores.locations.address.long.label')}
            placeholder={t('mores.locations.address.long.placeholder')}
          />
        </Col>
      </Row>
    </Card>
  );
}
